import { ApiResponse, TradevestOnboardingIssue, TradevestOnboardingOversightResponse } from '@mygate/common';
import { api } from './api';

export interface OnboardingOversightParams {
  issue?: TradevestOnboardingIssue;
  country?: string;
  page?: number;
  limit?: number;
}

/** `URLSearchParams` as the rest of the backoffice services do it, rather than a hand-rolled copy. */
const buildQuery = (params: Record<string, unknown>): string => {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '') continue;
    search.append(key, String(value));
  }
  const query = search.toString();
  return query ? `?${query}` : '';
};

/** Backoffice client for the Tradevest onboarding oversight endpoint (staff-only, read-only). */
class TradevestOnboardingService {
  async listOnboardings(
    params: OnboardingOversightParams = {},
  ): Promise<ApiResponse<TradevestOnboardingOversightResponse>> {
    return api.get(`/api/staff/tradevest/onboardings${buildQuery(params as Record<string, unknown>)}`);
  }
}

export const tradevestOnboardingService = new TradevestOnboardingService();
